import { Button, Checkbox, Col, Form, List, Radio, Row, Select, Tabs } from "antd";
import React from "react";
import FilterContainer from "../../../components/common/FilterContainer";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";

import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

import { BsFillInfoCircleFill } from "react-icons/bs";
import { useState } from "react";

import "./Messages.css";
import { messages, messageTabs } from "../../../data/messages";
import { useNavigate } from "react-router-dom";

const MessagesRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Texting Settings", "1", "", "", "/generalsettings/communication/text-settings"),
  ]),

  RightBarMethod(
    " HELP TOPICS",
    "t2",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Text Messaging Inbox", "2", "", "", "/")]
  ),
];

function Messages() {
  const [search, setSearch] = useState(false);
  const [checked, setChecked] = useState(false);

  const navigate = useNavigate();

  const onChange = () => {
    setChecked(!checked);
  }
  return (
    <>
      <div className="messages">
        <PageHeading heading="Messages" />
        <Row>
          <Col span={24}>
            <FilterContainer heading="Filter text messages by using any of the search filters below:">
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="User">
                      <Select
                        showSearch
                        placeholder="Search by ser email"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{
                          width: "100%",
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Person">
                      <Select
                        showSearch
                        placeholder="Search by tenant, owner, vendor, applicant, or prospect"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{
                          width: "100%",
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Property">
                      <Select
                        showSearch
                        placeholder="Search by property, group, or portfolio"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{
                          width: "100%",
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24} className="message-items">
                    <Form.Item label="Messages" >
                      <Tabs defaultActiveKey="1" items={messageTabs} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Checkbox>
                        Set these as my default filters (your unread count will
                        reflect these filters)
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item label=" ">
                  <Button type="primary" htmlType="submit" onClick={()=>setSearch(true)}>
                    Search
                  </Button>
                </Form.Item>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        {/* {search ? (
          <Row className="messages-container">
            <Col span={24}>
                {
                  messages.map((item, index)=>{
                    return(
                      <Row key={index} align="middle" className="message-details-container" onClick={()=>navigate(`/communication/messages/${item.id}`)}>
                        <Col span={1}>
                          <Radio checked={checked} onChange={()=>onChange()}></Radio>
                        </Col>
                        <Col span={23}>
                          <Row>
                            <Col span={23} className="name-container">{item.messageType === "sent" ? item.senderName + " " + " to " + item.recieverName : item.contact}</Col>
                            <Col span={23} className="date-container">{item.messageType} {item.date} at {item.time}</Col>
                            <Col span={23} className="message-container">{item.message}</Col>
                          </Row>
                        </Col>
                        { item.userType === "Vendor" ? <span className="user-type">{item.userType}</span> : null }
                        {
                          checked ? <Checkbox></Checkbox> : null
                        }
                      </Row>
                    )
                  })
                }
            </Col>
          </Row>
        ) : ( */}
          <Row
            justify="center"
            align="middle"
            gutter={[10, 0]}
            className="messages-container font-color"
          >
            <Col>
              <BsFillInfoCircleFill size={18} />
            </Col>
            <Col>
              <span>No text messages match your filters.</span>
            </Col>
          </Row>
        {/* )} */}
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={MessagesRightBar} />
      </div>
    </>
  );
}

export default Messages;
